var _style, _path, _ellipse, _ellipse2, _path2, _path3, _ellipse3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _ellipse4, _circle2, _path15, _rect, _path16, _circle3, _path17, _circle4, _path18, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a7e92c1a-e25c-441e-bda8-8af90c7203b5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 996.6 804",
    style: {
      enableBackground: "new 0 0 996.6 804"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#3F3D56;}\n\t.st2{opacity:0.1;enable-background:new    ;}\n\t.st3{fill:#CC3333;}\n\t.st4{fill:#2F2E41;}\n\t.st5{fill:#A0616A;}\n\t.st6{opacity:0.3;fill:#F50057;enable-background:new    ;}\n\t.st7{fill:#FF6584;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.2,9c-50.9,13.2-95.9,48.6-140.5,94.9c31.1,28.3,33.3,76.5,5,107.6c-27.4,30-73.5,33.3-104.8,7.4 c-52.5,62.7-109.7,128.9-179.6,183.7c-178,139.4,188,393.7,420,393.7s420-176.2,420-393.7S690.8-49.1,467.2,9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 532.6,
    cy: 773.5,
    rx: 464,
    ry: 30.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 545.6,
    cy: 771,
    rx: 160,
    ry: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M937.4,739.5c0,29.3-17.4,39.5-38.9,39.5c-0.5,0-1,0-1.5,0c-1,0-2-0.1-3-0.1c-19.4-1.4-34.4-12.1-34.4-39.3 c0-28.2,36-63.7,38.7-66.3l0,0c0.1-0.1,0.2-0.2,0.2-0.2S937.4,710.2,937.4,739.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M897.1,774.5l14.2-19.9l-14.3,22v2.3c-1,0-2-0.1-3-0.1l1.5-29.3v-0.2l0,0l0.1-2.8l-14.3-22.1l14.3,20v0.6 l1.2-22.1l-12.2-22.8l12.4,19l1.2-45.9V673v0.2l-0.2,36.2l12.2-14.3L898,712.6l-0.3,19.8l11.4-19l-11.4,21.9l-0.2,11l16.5-26.5 L897.5,750L897.1,774.5z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 210.1806 632.5629)",
    className: "st4",
    cx: 476.8,
    cy: 192.8,
    rx: 47.8,
    ry: 47.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "586.7,614.8 612.3,717.7 637.8,713.6 612.3,595.9 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M621.3,711.2c0,0-14.5,4.9-12.6,8.2s1.9,23.9-4.7,31.3s-23.1,30.5-4.1,31.3s37.9-11.5,37.9-11.5V749l3.3,19.8 h3.3v-22.2c0,0,8.2-14,3.3-22.2s-8.2-15.4-14.4-14.7S621.3,711.2,621.3,711.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "486.3,702.1 482.1,724.3 511,724.3 511,702.1 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M488.7,719.4c0,0-8.2-0.8-10.7,10.7s-24.7,28-32.9,30.5s-8.2,10.7,2.5,12.4s37.9,2.5,44.5-6.6 c4.5-5.9,9.7-11.2,15.6-15.6l-4.1,23.1h7.4c0,0,6.6-22.2,13.2-29.6s-13.2-24.7-16.5-24.7L488.7,719.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M448.4,365.3c0,0-5.8,15.6-15.6,18.1s-83.2,19.8-83.2,19.8s-64.2,1.6-44.5,15.6s51.9,0,51.9,0 s93.9-11.5,101.3-23.9c4.9-8.4,9-17.2,12.4-26.4L448.4,365.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M479.7,296.1c0,0-46.9,76.6-41.2,78.2s59.3,18.9,61.8,12.4s2.5-37.1,2.5-37.1L479.7,296.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.7,296.1c0,0-46.9,76.6-41.2,78.2s59.3,18.9,61.8,12.4s2.5-37.1,2.5-37.1L479.7,296.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M601.6,278l106.2,54.4c0,0,60.1,15.6,46.9,28s-56-10.7-56-10.7L581,296.1L601.6,278z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.7,235.2c0,0,20.6,31.3,18.9,38.7c0,0,1.6,4.9-0.8,8.2s-1.6,23.1-1.6,23.1l8.2,11.5l10.7-35.4l4.9-37.9 c0,0-11.1-15.2-9.5-22.6S465.7,235.2,465.7,235.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M530.7,413c0,0-46.1,123.5-46.1,177.9s-17.3,116.1-4.1,121.9s79.9,6.6,81.5,0s-8.2-274.2-13.2-284.9 S530.7,413,530.7,413z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M530.7,413c0,0-46.1,123.5-46.1,177.9s-17.3,116.1-4.1,121.9s79.9,6.6,81.5,0s-8.2-274.2-13.2-284.9 S530.7,413,530.7,413z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 476.4,
    cy: 209.6,
    r: 30.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M485.4,301.9l-2.2-18.6c0,0-6.9,9.5-6.9,16.9s-4.1,33.8,13.2,50.2s20.6,19.8,21.4,23.1s4.9,3.3,4.9,3.3 l23.9,96.3c0,0,7.4,256.1,18.9,259.4s46.9,0,49.4-4.1s-4-113.6-4-113.6s18.1,97.2,24.7,97.2s10.7-14,9.1-14.8s-11.5-64.2-15.6-84 s-2.5-186.9-2.5-186.9s13.2-21.4-32.1-63.4c0,0-28.8-84-30.5-84s-33.8-45.3-33.8-45.3s-18.1,0-21.4,10.7S485.4,301.9,485.4,301.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M513.4,240.1l9.9-6.6c0,0,41.2,24.7,70,26.4s28,18.1,16.5,29.6s-56.8,51.1-58.5,41.2S513.4,240.1,513.4,240.1z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 476.8,
    cy: 179.6,
    rx: 32.9,
    ry: 19.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 480.1,
    cy: 145,
    r: 19.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.7,134.3c0-10.1,7.6-18.6,17.7-19.7c-0.7-0.1-1.4-0.1-2.1-0.1c-10.9,0-19.8,8.9-19.7,19.8 c0,10.9,8.8,19.7,19.7,19.7c0.7,0,1.4,0,2.1-0.1C461.4,152.9,453.7,144.4,453.7,134.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 328.4,
    y: 376.6,
    transform: "matrix(0.9861 -0.1659 0.1659 0.9861 -76.2469 98.1113)",
    className: "st1",
    width: 441.5,
    height: 257.8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M683.9,425.6l-289.1,48.1c-3.2,0.5-6.3-1.6-6.8-4.9c-0.5-3.2,1.6-6.3,4.9-6.8l0,0L682,413.8 c3.2-0.5,6.3,1.7,6.8,4.9C689.3,422,687.1,425,683.9,425.6L683.9,425.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 604.2,
    cy: 432.8,
    r: 24.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M694.7,490.1l-289.1,48.1c-3.2,0.5-6.3-1.6-6.8-4.9c-0.5-3.2,1.6-6.3,4.9-6.8l0,0l289.1-48.1 c3.2-0.5,6.3,1.7,6.8,4.9C700.1,486.5,697.9,489.6,694.7,490.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 484.2,
    cy: 519.1,
    r: 24.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M705.4,554.6l-289.1,48.1c-3.2,0.5-6.3-1.7-6.8-4.9s1.7-6.3,4.9-6.8l289.1-48.1c3.2-0.5,6.3,1.6,6.9,4.9 S708.6,554.1,705.4,554.6L705.4,554.6z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 584.6,
    cy: 568.7,
    r: 24.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 275.4,
    cy: 160.2,
    r: 54.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPage);
export default __webpack_public_path__ + "static/media/SettingsPage.4cd865e6a5b0f65418bde6484aca2bc1.svg";
export { ForwardRef as ReactComponent };